import React from "react";
import "./Policy.css";

export default function RefundPolicy() {
  return (
    <div className="policy-page">
      <h1>Refund & Cancellation Policy</h1>
      <p>Last updated: August 2025</p>

      <h2>1. Subscription Plans</h2>
      <p>
        TravXplo subscriptions are billed based on the number of itineraries
        (e.g., Silver, Gold, Diamond plans). These are one-time or recurring
        payments depending on the plan chosen.
      </p>

      <h2>2. Cancellations</h2>
      <p>
        You may cancel your subscription at any time. Cancellation will stop
        future billing but will not refund the current billing period.
      </p>

      <h2>3. Refunds</h2>
      <p>
        Since our services provide instant digital access (AI-generated
        itineraries), refunds are generally <strong>not offered</strong>.
        However, if you experience technical issues that prevent you from using
        your plan, please reach out to us at{" "}
        <strong>travxplo@gmail.com</strong> and we will review your request.
      </p>

      <h2>4. Contact Us</h2>
      <p>
        For any payment or billing issues, email us at{" "}
        <strong>travxplo@gmail.com</strong>.
      </p>
    </div>
  );
}
